import { config } from "src/stateManagement/redux/configVar";

// export const sharedReport =
//     (): ReduxThunkAction =>
//         async (dispatch, getState) => {
//             dispatch(mainSlice.actions.updateState({ status: true }));

//             try {
//                 let token = localStorage.getItem("authToken");

//                 if (!token) {
//                     return;
//                 }

//                 if (!download && !sendEmail) {
//                     dispatch(
//                         mainSlice.actions.addToastNotification({
//                             id: `${mainSlice.actions.addToastNotification.length + 1
//                                 }`,
//                             message:
//                                 "Debes seleccionar al menos una opción para compartir el reporte",
//                             type: "error",
//                             duration: 5000,
//                         })
//                     );
//                     return;
//                 }

//                 const headers = {
//                     "Content-Type": "application/json",
//                     authorization: `${token}`,
//                     report_id: reportId,
//                     report_code: reportCode,
//                     start_date: formatDateToYYYYMMDD(startDate),
//                     end_date: formatDateToYYYYMMDD(endDate),
//                     project_id: projectId,
//                     emails_to_shared: JSON.stringify(email),
//                     sendEmail: sendEmail.toString(),
//                     download: download.toString(),
//                 };

//                 const response = await fetch(
//                     `${serverUrl}/api/reports/shareReport`,
//                     {
//                         method: "GET",
//                         headers,
//                     }
//                 );

//                 if (response?.status === 401 && allowLogOut) {
//                     localStorage.removeItem("authToken");
//                     dispatch(
//                         mainSlice.actions.addToastNotification({
//                             id: `${mainSlice.actions.addToastNotification.length + 1
//                                 }`,
//                             message:
//                                 "Token ha expirado, por favor inicia sesión nuevamente",
//                             type: "error",
//                             duration: 5000,
//                         })
//                     );
//                     dispatch(mainSlice.actions.activeUser());
//                     return;
//                 }

//                 if (response?.status !== 200 && response?.status !== 201) {
//                     dispatch(
//                         mainSlice.actions.addToastNotification({
//                             id: `${mainSlice.actions.addToastNotification.length + 1
//                                 }`,
//                             message:
//                                 "No se podido enviar el reporte al correo, intentalo luego",
//                             type: "error",
//                             duration: 5000,
//                         })
//                     );
//                 } else {
//                     if (sendEmail) {
//                         dispatch(
//                             mainSlice.actions.addToastNotification({
//                                 id: `${mainSlice.actions.addToastNotification.length +
//                                     1
//                                     }`,
//                                 message:
//                                     "Se ha programado el envio del reporte al correo",
//                                 type: "success",
//                                 duration: 5000,
//                             })
//                         );
//                     }

//                     if (response?.status !== 200 && response?.status !== 201) {
//                         dispatch(
//                             mainSlice.actions.addToastNotification({
//                                 id: `${mainSlice.actions.addToastNotification.length +
//                                     1
//                                     }`,
//                                 message:
//                                     "No se podido enviar el reporte al correo, intentalo luego",
//                                 type: "error",
//                                 duration: 5000,
//                             })
//                         );
//                     } else {
//                         if (sendEmail) {
//                             dispatch(
//                                 mainSlice.actions.addToastNotification({
//                                     id: `${mainSlice.actions.addToastNotification
//                                             .length + 1
//                                         }`,
//                                     message:
//                                         "Se ha programado el envio del reporte al correo",
//                                     type: "success",
//                                     duration: 5000,
//                                 })
//                             );
//                         }

//                         if (response.ok && download) {
//                             const blob = await response.blob();
//                             const url = window.URL.createObjectURL(blob);
//                             const a = document.createElement("a");
//                             a.href = url;


//                             const contentDisposition = response.headers.get(
//                                 "Content-Disposition"
//                             );

//                             if (contentDisposition) {
//                                 a.download =
//                                     contentDisposition.split("filename=")[1];
//                             }
//                             document.body.appendChild(a);
//                             a.click();
//                             document.body.removeChild(a);
//                             window.URL.revokeObjectURL(url);
//                         }
//                     }
//                 }
//             } catch (error) {
//                 console.log({ error });
//             } finally {
//                 dispatch(mainSlice.actions.updateState({ status: false }));
//             }
//         };

export const downloadExcelFormat = async (typeOrFormat: string): Promise<void> => {
    try {

        const serverUrl = config.serverUrl

        let token = localStorage.getItem("authToken");

        if (!token) {
            return;
        }

        const headers: any = {
            "Content-Type": "application/json",
            authorization: `${token}`,
            typeOrFormat,
        }

        const response = await fetch(
            `${serverUrl}/api/reports/getExcelFormat`,
            {
                method: "GET",
                headers,
            }
        );

        if (response?.status === 401) {
            return;
        }

        if (response?.status !== 200 && response?.status !== 201) {
            return;
        }

        // const data = await response.json();
        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        const contentDisposition = response.headers.get(
            "Content-Disposition"
        );

        if (contentDisposition) {
            a.download =
                contentDisposition.split("filename=")[1];
        }
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);

        // return data;
    } catch (error) {
        console.log({ error });
    }
}

export const downloadExcelFormatAnalyst = async (startDate: string, endDate: string, downloadOnlyCurrentUser?: boolean): Promise<void> => {
    try {

        const serverUrl = config.serverUrl

        let token = localStorage.getItem("authToken");

        if (!token) {
            return;
        }

        const headers: any = {
            "Content-Type": "application/json",
            authorization: `${token}`,
            start_date: startDate,
            end_date: endDate,
            downloadOnlyCurrentUser
        }

        const response = await fetch(
            `${serverUrl}/api/reports/getExcelWellAnalysistReport`,
            {
                method: "GET",
                headers,
            }
        );

        if (response?.status === 401) {
            return;
        }

        if (response?.status !== 200 && response?.status !== 201) {
            return;
        }

        // const data = await response.json();
        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        const contentDisposition = response.headers.get(
            "Content-Disposition"
        );

        if (contentDisposition) {
            a.download =
                contentDisposition.split("filename=")[1];
        }
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);

        // return data;
    } catch (error) {
        console.log({ error });
    }
}

export const downloadExcelForOperations = async (start_date:string,end_date:string,type_of_search: string, responseFormat: string, locations?: string): Promise<void> => {
    try {

        const serverUrl = config.serverUrl

        let token = localStorage.getItem("authToken");

        if (!token) {
            return;
        }

        const headers: any = {
            "Content-Type": "application/json",
            authorization: `${token}`,
            start_date,
            end_date,
            type_of_search,
            responseFormat
        }

        // Agregar locations solo si está presente
        if (locations && locations.trim() !== '') {
            headers["locations"] = locations;
        }

        const response = await fetch(
            `${serverUrl}/api/reports/getOperationsAdvanceReport`,
            {
                method: "GET",
                headers,
            }
        );

        if (response?.status === 401) {
            return;
        }

        if (response?.status !== 200 && response?.status !== 201) {
            return;
        }

        // const data = await response.json();
        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        const contentDisposition = response.headers.get(
            "Content-Disposition"
        );

        if (contentDisposition) {
            a.download =
                contentDisposition.split("filename=")[1];
        }
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);

        // return data;
    } catch (error) {
        console.log({ error });
    }
}